@import "../global.css";
@import "../shadow.css";
@import "../../internal/skins/minimal-video/skin.css";
